import { io, Socket } from 'socket.io-client';
import { API_BASE_URL, refreshSession } from '../store/api/apiClient';

// Socket.io is served from the API origin, not under the /app REST prefix.
const SOCKET_URL = API_BASE_URL.replace(/\/app(\/v1)?\/?$/, '');

const AUTH_ERROR_MESSAGES = ['Authentication required', 'Invalid token'];

let socket: Socket | null = null;

/** Auth travels via the httpOnly access-token cookie (sent automatically with
 * withCredentials), not a client-supplied token. */
export function connectSocket(): Socket {
  if (socket?.connected) return socket;

  const newSocket = io(SOCKET_URL, {
    withCredentials: true,
    transports: ['polling', 'websocket'],
    reconnection: true,
    reconnectionDelay: 2000,
  });

  // Socket.io doesn't auto-reconnect after a middleware rejection, so an expired
  // access cookie needs one refresh + reconnect; the flag stops a refresh loop.
  let hasRetriedAuth = false;
  newSocket.on('connect', () => {
    hasRetriedAuth = false;
  });
  newSocket.on('connect_error', async (error) => {
    if (hasRetriedAuth || !AUTH_ERROR_MESSAGES.includes(error.message)) return;
    hasRetriedAuth = true;
    const refreshed = await refreshSession();
    if (refreshed && socket === newSocket) newSocket.connect();
  });

  socket = newSocket;
  return newSocket;
}

export function disconnectSocket() {
  socket?.disconnect();
  socket = null;
}

export function getSocket(): Socket | null {
  return socket;
}
